/**
 * @fileoverview The `appKey` prop validator the marketing chrome shares (LIFE-SHORTLISTED-001
 * P10.4 / P10.5). `<MarketingHeader>` and `<MarketingFooter>` look a Colony marketing site's brand up in
 * brand-assets by `appKey`; a white-label tenant site has no entry there and describes its brand
 * with a self-describing `brandIdentity` instead. So `appKey` is required unless `brandIdentity` is
 * given, and is a string whenever it is.
 * @module @puffin-core/marketing-shell/components/appKeyPropType
 */

/**
 * @param {Object} props
 * @param {string} propName
 * @param {string} componentName
 * @returns {?Error}
 */
export function appKeyPropType(props, propName, componentName) {
  const value = props[propName];
  if (value === undefined) {
    return props.brandIdentity
      ? null
      : new Error(
          `The prop \`${propName}\` is required in \`${componentName}\` unless \`brandIdentity\` describes the brand.`,
        );
  }
  return typeof value === 'string'
    ? null
    : new Error(
        `Invalid prop \`${propName}\` of type \`${typeof value}\` supplied to \`${componentName}\`, expected \`string\`.`,
      );
}
